// extracted by mini-css-extract-plugin
module.exports = {"container":"primitive_container__3aTV0","string":"primitive_string__3yb39","number":"primitive_number__CYVL1","null":"primitive_null__3Rk0r","boolean":"primitive_boolean__2nkMk"};